import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  StyledTableCell,
  StyledTableRow,
  useStyles,
} from "components/profiles/ProfileStyles";
import Actions from "./ActivityCategoriesTableActions";
import { doTruncarStr } from "utils/general/TruntecStr";
import { compareStrings } from "utils/sort/strings";
import { createContent } from "utils/tables/createContent";

function desc(a, b, orderBy) {
  if (a[orderBy] === null || a[orderBy] === undefined) {
    a[orderBy] = "";
  }
  if (b[orderBy] === null || b[orderBy] === undefined) {
    b[orderBy] = "";
  }

  return compareStrings(a[orderBy].toString(), b[orderBy].toString());
}

const ActivityCategoriesTable = props => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState({});
  const [rowsLength, setRowsLength] = useState(0);
  const [headers, setHeaders] = useState([]);
  const [mainField, setMainField] = useState("");
  const [visibleHeaders, setVisibleHeaders] = useState([]);
  const [sortedFields, setSortedFields] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");

  React.useEffect(() => {
    setHeaders(props.headers);
    setRows(props.rows);
    setRowsLength(props.rows.length);
    setMainField(props.mainField);
    setVisibleHeaders(props.visibleHeaders);
    setSortedFields(props.sortedFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.headers, props.mainField, props.rows, props.visibleHeaders]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }
  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === sortedFields[property] && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(sortedFields[property]);
  };

  const UsersTableHead = props => {
    const { order, orderBy, onRequestSort } = props;
    const [t] = useTranslation();
    const paginationTop = action => e => {
      var selector = "[aria-label^='" + action + "']";
      document.querySelector(selector).click();
      e.preventDefault();
    };
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {visibleHeaders.map((header, index) => (
            <StyledTableCell
              key={index}
              size="small"
              align="left"
              sortDirection={orderBy === sortedFields[index] ? order : false}
            >
              <TableSortLabel
                active={orderBy === sortedFields[index]}
                direction={order}
                onClick={createSortHandler(index)}
                disabled={index === 3}
              >
                {header.toUpperCase()}
                {orderBy === sortedFields[index] ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  UsersTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  React.useEffect(() => {
    if (props.toFirstPage) {
      document.getElementById("toFirstPage").click();
    }
  }, [props.rows, props.toFirstPage]);

  const toFirstPage = () => {
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} size="small">
          {rows.length > 0 && (
            <UsersTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
          )}
          <TableBody>
            {createContent(rows, headers, order, orderBy, desc)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => (
                <StyledTableRow key={row.id}>
                  <TableCell size="small" style={{ width: "25%" }}>
                    {row["name"] ? doTruncarStr(row["name"], 50) : "-"}
                  </TableCell>
                  <TableCell size="small" style={{ width: "60%" }}>
                    {row["description"]
                      ? doTruncarStr(row["description"], 50)
                      : "-"}
                  </TableCell>
                  <TableCell
                    size="small"
                    align="right"
                    style={{ width: "15%" }}
                  >
                    <div
                      style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                        display: "flex",
                        flexWrap: "nowrap ",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Actions
                        item={row}
                        name={row.name}
                        permission={props.permission}
                        fetchData={props.fetchData}
                        activityCategories={props.activityCategories}
                      />
                    </div>
                  </TableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
        <button hidden id="toFirstPage" onClick={toFirstPage}></button>
        {rows.length > 0 && (
          <TableFooter style={{ float: "right" }}>
            <TablePagination
              labelRowsPerPage={"Resultados por página"}
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              component="div"
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          </TableFooter>
        )}
      </div>
    </Paper>
  );
};

ActivityCategoriesTable.propTypes = {
  rows: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  visibleHeaders: PropTypes.array.isRequired,
  mainField: PropTypes.string.isRequired,
};

export default ActivityCategoriesTable;
